/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InvoiceSummaryPathParams, InvoiceSummaryResponse } from '../types/InvoiceSummary'

/**
 * GET /:organisation/invoices/summary
 * @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::summary
 */
export async function invoiceSummary(
	organisation: InvoiceSummaryPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InvoiceSummaryResponse>> {
	return axiosInstance.get(`/${organisation}/invoices/summary`, config)
}
